import { UseInfiniteQueryResult } from '@tanstack/react-query';
import { useScrollToBottomCallback } from './useScrollToBottomCallback.ts';


export function useLoadMoreOnScroll(infiniteQuery: UseInfiniteQueryResult<any, unknown>) {
    useScrollToBottomCallback({
        callback: infiniteQuery.fetchNextPage,
        enabled: infiniteQuery.hasNextPage && !infiniteQuery.isFetching,
    });
}
